(function () {
  if (customElements.get('fall-sale-countdown')) return;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  class FallSaleCountdown extends HTMLElement {
    connectedCallback() {
      var endAttr = this.getAttribute('data-end');
      this.endTime = endAttr ? new Date(endAttr).getTime() : NaN;
      this.endedText = this.getAttribute('data-ended-text') || 'Sale has ended';
      this.boxed = this.getAttribute('data-style') === 'boxed';

      if (isNaN(this.endTime)) {
        this.hidden = true;
        return;
      }

      if (this.boxed) {
        this.innerHTML =
          '<div class="fsc-box"><span class="fsc-box__num" data-unit="d">00</span><span class="fsc-box__label">Days</span></div>' +
          '<div class="fsc-box"><span class="fsc-box__num" data-unit="h">00</span><span class="fsc-box__label">Hrs</span></div>' +
          '<div class="fsc-box"><span class="fsc-box__num" data-unit="m">00</span><span class="fsc-box__label">Min</span></div>' +
          '<div class="fsc-box"><span class="fsc-box__num" data-unit="s">00</span><span class="fsc-box__label">Sec</span></div>';
      }

      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    tick() {
      var diff = this.endTime - Date.now();

      if (diff <= 0) {
        if (this.timer) clearInterval(this.timer);
        this.classList.add('fall-sale-countdown--ended');
        this.textContent = this.endedText;
        return;
      }

      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      if (this.boxed) {
        var dEl = this.querySelector('[data-unit="d"]');
        var hEl = this.querySelector('[data-unit="h"]');
        var mEl = this.querySelector('[data-unit="m"]');
        var sEl = this.querySelector('[data-unit="s"]');
        if (dEl) dEl.textContent = pad(d);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      } else {
        var parts = [];
        if (d > 0) parts.push(d + 'd');
        parts.push(pad(h) + 'h', pad(m) + 'm', pad(s) + 's');
        this.textContent = parts.join(' ');
      }
    }
  }

  customElements.define('fall-sale-countdown', FallSaleCountdown);
})();
